import { useSelector } from 'react-redux';
import { GAME_CLASS, name } from './constants';
export var gameTypesSelector = function (state) { return state[name]; };
export var gameBalanceSelector = function (state) {
    return gameTypesSelector(state).data.gameBalance;
};
export var activeGameSelector = function (state) {
    return gameTypesSelector(state).data.activeGame;
};
export var selectedTournamentSelector = function (state) {
    return gameTypesSelector(state).meta.tournament;
};
export var defaultGameUidSelector = function (state) { var _a; return (_a = gameTypesSelector(state).meta) === null || _a === void 0 ? void 0 : _a.defaultGameUid; };
export var isEasyPlusSelector = function (state) { var _a; return ((_a = gameTypesSelector(state).data.activeGame) === null || _a === void 0 ? void 0 : _a.gameClass) === GAME_CLASS.EASY_PLUS; };
export var isEasyTipSelector = function (state) {
    var _a, _b;
    return ((_a = gameTypesSelector(state).data.activeGame) === null || _a === void 0 ? void 0 : _a.gameClass)
        ? ((_b = gameTypesSelector(state).data.activeGame) === null || _b === void 0 ? void 0 : _b.gameClass) ===
            GAME_CLASS.EASY_TIP
        : undefined;
};
export var useGameBalanceSelector = function () { return useSelector(gameBalanceSelector); };
export var useActiveGameSelector = function () { return useSelector(activeGameSelector); };
export var useTournamentSelector = function () {
    return useSelector(selectedTournamentSelector);
};
export var useDefaultGameUidSelector = function () {
    return useSelector(defaultGameUidSelector);
};
export var useIsEasyPlusSelector = function () { return useSelector(isEasyPlusSelector); };
export var useIsEasyTipSelector = function () { return useSelector(isEasyTipSelector); };
